import { del, get, post, put } from "../../utils/fetchAPI";

// Generic group library helpers. `type` selects the kind ("advice", "labTest", ...).
export const getGroups = async (doctorId, type) => {
    const res = await get(`/doctor/group/list/${doctorId}?type=${type || ""}`);
    return res;
};

export const createGroup = async (payload) => {
    // payload: { doctorId, name, type }
    const res = await post(`/doctor/group`, payload);
    return res;
};

export const updateGroup = async (groupId, name) => {
    const res = await put(`/doctor/group/${groupId}`, { name });
    return res;
};

export const deleteGroup = async (groupId) => {
    const res = await del(`/doctor/group/${groupId}`);
    return res;
};

// Persist the doctor's drag-sorted order of a group's members. The order lives
// on the group (not the item) because one item can belong to several groups.
export const reorderGroupItems = async (groupId, itemIds) => {
    const res = await put(`/doctor/group/${groupId}/reorder`, { itemIds });
    return res;
};

// Replace the full set of groups an advice belongs to (multi-select semantics).
export const setAdviceGroups = async (payload) => {
    // payload: { adviceId, doctorId, groups: [groupId] }
    const res = await put(`/doctor/advice/set-groups`, payload);
    return res;
};

// ---- Group-centric advice membership (used by the Groups settings tab) ----

// Advice currently in a group.
export const getGroupAdvices = async (doctorId, groupId) => {
    const res = await get(`/doctor/advice-list/${doctorId}?groupId=${groupId || ""}`);
    return res;
};

// Search the doctor's full advice library (for adding to a group).
export const searchDoctorAdvices = async (doctorId, search) => {
    const res = await get(`/doctor/advice-list/${doctorId}?search=${search || ""}`);
    return res;
};

export const addAdviceToGroup = async (payload) => {
    // payload: { adviceId, doctorId, groupId }
    const res = await put(`/doctor/advice/add-to-group`, payload);
    return res;
};

export const removeAdviceFromGroup = async (payload) => {
    // payload: { adviceId, doctorId, groupId }
    const res = await put(`/doctor/advice/remove-from-group`, payload);
    return res;
};

// Replace the full set of groups a lab test belongs to (multi-select semantics).
export const setLabTestGroups = async (payload) => {
    // payload: { labTestId, doctorId, groups: [groupId] }
    const res = await put(`/doctor/lab-test/set-groups`, payload);
    return res;
};

// ---- Group-centric lab test membership (used by the Groups settings tab) ----

// Lab tests currently in a group.
export const getGroupLabTests = async (doctorId, groupId) => {
    const res = await get(`/lab-test-list/${doctorId}?groupId=${groupId || ""}`);
    return res;
};

// Search the doctor's full lab test library (for adding to a group).
export const searchDoctorLabTests = async (doctorId, search) => {
    const res = await get(`/lab-test-list/${doctorId}?search=${search || ""}`);
    return res;
};

export const addLabTestToGroup = async (payload) => {
    // payload: { labTestId, doctorId, groupId }
    const res = await put(`/doctor/lab-test/add-to-group`, payload);
    return res;
};

export const removeLabTestFromGroup = async (payload) => {
    // payload: { labTestId, doctorId, groupId }
    const res = await put(`/doctor/lab-test/remove-from-group`, payload);
    return res;
};
